import { isLocalDevHostname, resolveApiUrl } from '~/utils/resolveApiUrl';

/**
 * Browser URL for the LE Lens API (`/api/reporting/le-lenses...`).
 *
 * LE Lens has its own local origin, deliberately separate from
 * `REPORTING_LE_DATA_SVC_ORIGIN` (the chat origin). That origin stays pointed at production so
 * the chat keeps showing real threads; production does not yet serve LE Lens routes, so lens
 * calls need a different local target while the feature is still only in local svc-reporting.
 *
 * - **Local**: `REPORTING_LE_LENS_SVC_ORIGIN`, so lens traffic hits a local svc-reporting.
 * - **Other hosts** (test/prod): `API_HOST` via {@link resolveApiUrl}, same as every other route.
 */
export function resolveReportingLeLensUrl(path: string): string {
  if (typeof window === 'undefined') {
    return path.startsWith('/') ? path : `/${path}`;
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;

  const base = String(window.configs?.REPORTING_LE_LENS_SVC_ORIGIN ?? '')
    .trim()
    .replace(/\/$/, '');

  if (base) {
    return `${base}${normalized}`;
  }

  if (isLocalDevHostname()) {
    throw new Error('REPORTING_LE_LENS_SVC_ORIGIN is required for local LE Lens development');
  }

  return resolveApiUrl(normalized);
}
